//
// Test lab
//
// For test dev

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'

import { VView } from '../../appview'

import { testMetadata, testMetadataFields } from '../../stores/data/utils'

const test = languages => {
    console.log('testMetadata', testMetadata)
    for (const [testname, testfunction] of Object.entries(testMetadataFields)) {
        let [new_metadata, is_updated] = testfunction(testMetadata, languages)
        console.log(testname, is_updated, new_metadata)
    }
}

export const Test = observer(function Test() {
    const { project } = useStore()

    return (
        <VView style={{ padding: 20 }} gap={20}>
            1, 2, 3…
            <br />
            <button onClick={() => test(project.languages)}>TEST METADATA</button>
        </VView>
    )
})
